import { getViewData } from './viewSlice/index';
import { getUserData } from './userSlice';
import { getOfferData } from "./offerSlice";

export const select = {
    offer: getOfferData,
    user: getUserData,
    view: getViewData
}